<template>
<div class="chapter">
<div class="inner_page">
<p class="p11"><span class="sz"><b>Prologue</b></span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p13"><span class="sz"><i>Boston, Massachusetts</i></span></p>
<p class="p13"><span class="sz"><span class="s3">"F</span>ather," Elise said, after tapping on the door, which was already slightly ajar. Family meant everything to Oliver Malloy, and his wife or any of his four children knew they were always welcome to enter his study.</span></p>
<p class="p14"><span class="sz">He looked up from the paper he was perusing. "Yes, sweetcake?"</span></p>
<p class="p14"><span class="sz"><i>Sweetcake</i>—the nickname for a child. Yet at 21 years, Elise was a child no longer. Today, she wanted to ask him a particularly delicate favor, perhaps the hardest thing she'd ever done, and it caused her stomach to clench with apprehension.</span></p>
<p class="p14"><span class="sz">"Are you terribly busy?" she stalled as her heart raced.</span></p>
<p class="p14"><span class="sz">"Never too busy for you." He removed his glasses and gave her his attention.</span></p>
<p class="p14"><span class="sz">She walked around her father's paper-strewn desk and leaned against the edge of it, looking down at his intelligent, kind face.</span></p>
<p class="p14"><span class="sz">"Remember that man we met today?"</span></p>
<p class="p14"><span class="sz">He wrinkled his nose while thinking, a habit her youngest sister, Rose, had as well.</span></p>
<p class="p14"><span class="sz">"A number of men crossed our path today." He smiled gently and cocked his head, once full of dark hair that was now mostly gray. "Which one?"</span></p>
<p class="p14"><span class="sz">"At the bank, Father. You remember? The tall one with the coffee-colored hair and thoughtful hazel eyes."</span></p>
<p class="p14"><span class="sz">Her father's eyebrows shot up while his eyes widened. "Oh!... Hm. Let's see. Hazel eyes, brown hair. The handsome young one, correct?" He couldn't help teasing her.</span></p>
<p class="p14"><span class="sz">She blushed and nodded.</span></p>
<p class="p14"><span class="sz">"You're interested in him, I take it."</span></p>
<p class="p14"><span class="sz">She loved that he got right to the point. Shyly, she nodded again. "Would you find out if he is attached?"</span></p>
<p class="p14"><span class="sz">Her father looked at her with his inky blue eyes so like her own. Reaching out, he patted her hand. "I'm glad you're not still grieving over young Randall."</span></p>
<p class="p14"><span class="sz">The mention of her dear friend who had passed from consumption two summers earlier still elicited a wave of loneliness. They'd grown up side-by-side as next door neighbors, played together, learned to read together, ridden horses and shared their dreams, and it was widely assumed they would eventually declare a love match and marry. Her mind wandered to his fair-hair and blue eyes.</span></p>
<p class="p14"><span class="sz">"First, we need to know his name," her father said. "I don't believe I recall—"</span></p>
<p class="p14"><span class="sz">Her thoughts snapped back to the present. "His name is Mr. Bradley," she told her father softly. "Michael Bradley."</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section6.vue?4a6d60b4